export const domainName = "https://www.holidayisland.com";
export const apiURL = domainName + "/cp/api/public/";
export const widgetURL = domainName + "/cp/api/";
export const apiKey = "51ec77e35e6ddb56051bdab12fa9fd36b86d42e8175a48a10f8abfc701013b6c";
export const GACode = 'UA-368743-22';
